import { render, staticRenderFns } from "./DeptInputTree.vue?vue&type=template&id=2b887c59"
import script from "./DeptInputTree.vue?vue&type=script&lang=js"
export * from "./DeptInputTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports